import type * as z from "zod"
import type { AutoFormInputComponentProps } from "../types"
import { useTranslations } from "next-intl"
import { FormControl, FormItem, FormMessage } from "@/components/ui/form"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { cn } from "@/lib/utils"
import AutoFormLabel from "../common/label"
import AutoFormTooltip from "../common/tooltip"
import { getBaseSchema } from "../utils"

export default function AutoFormEnum({
  label,
  isRequired,
  field,
  fieldConfigItem,
  zodItem,
  fieldProps,
}: AutoFormInputComponentProps) {
  const t = useTranslations("auto_form")
  const baseValues = (getBaseSchema(zodItem) as unknown as z.ZodEnum<any>)._def.values as Record<string, string> | string[]

  let values: [string, string][] = []
  if (!baseValues) {
    // Si baseValues es null/undefined, usar array vacío
    values = []
  } else if (!Array.isArray(baseValues)) {
    values = Object.entries(baseValues)
  } else {
    values = baseValues.map(value => [value, value])
  }

  function findItem(value: string) {
    return values.find(item => item[0] === value)
  }

  return (
    <FormItem className={cn(fieldConfigItem?.containerClassName)}>
      <AutoFormLabel
        isRequired={isRequired}
        label={fieldConfigItem?.label ?? label}
      />
      <FormControl>
        <Select
          defaultValue={field.value}
          onValueChange={field.onChange}
          {...fieldProps}
        >
          <SelectTrigger className={cn("w-full", fieldProps.className)}>
            <SelectValue placeholder={fieldConfigItem.inputProps?.placeholder}>
              {field.value ? findItem(field.value)?.[1] : t("select_option")}
            </SelectValue>
          </SelectTrigger>
          <SelectContent>
            {values.map(([value, label]) => (
              <SelectItem key={value} value={label}>
                {label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormControl>
      <AutoFormTooltip fieldConfigItem={fieldConfigItem} />
      <FormMessage />
    </FormItem>
  )
}
